import { IMunicipality } from '../../../models/municipality.model';
import municipalityIcon from '../../../../assets/icons/locations/municipality-default-gray-900.svg';
import { TranslationService } from '../../../services/translation.service';

function MunicipalityListShowcase({ municipalities }: { municipalities: IMunicipality[] }) {
  return (
    <div className="municipality-list-showcase w-100">
      {municipalities.map((item) => (
        <div key={item.gid} className="d-flex flex-row gap-1 align-items-center">
          <div className="municipality-list-showcase__icon flex-shrink-0">
            <img src={municipalityIcon} alt="" />
          </div>
          <div className="municipality-list-showcase__municipality flex-shrink-0 text-center">
            <span className="visually-hidden">{TranslationService.get('common.municipality')}</span>
            {item.name}
          </div>
        </div>
      ))}
    </div>
  );
}

export default MunicipalityListShowcase;
